<template>
    <div class="pa-4">
        <TabsSliderContainer :tab.sync="tab" :items="items" />
    </div>
</template>
<script>
import TabsSliderContainer from '@/components/ui/TabsSliderContainer.vue';
import { mapActions } from 'vuex';

export default {
    name: 'PreTrialNotices',
    components: { TabsSliderContainer },
    data() {
        return {
            tab: null,
            items: [
                { tab: 'Для юридических лиц', content: 'ContractsNotices' },
                { tab: 'По лицевым счетам', content: 'AccountsNotices' }
            ]
        };
    },
    methods: {
        ...mapActions('refs', ['getJobPositionTypes'])
    },
    async mounted() {
        await this.getJobPositionTypes();
    }
};
</script>

<style scoped></style>
